export const CURRENCY_MAP = {
  'USD': '$',
  'EUR': '€',
  'GBP': '£',
  'ILS': '₪',
  'שח': '₪',
  'דולר': '$',
  'יורו': '€'
};

export const MAPPING_COLORS = [
  { main: '#1976d2', light: '#e3f2fd' },
  { main: '#2e7d32', light: '#e8f5e9' },
  { main: '#ed6c02', light: '#fff3e0' },
  { main: '#9c27b0', light: '#f3e5f5' },
  { main: '#d32f2f', light: '#ffebee' },
  { main: '#0288d1', light: '#e1f5fe' },
  { main: '#7b1fa2', light: '#f3e5f5' },
  { main: '#c2185b', light: '#fce4ec' },
  { main: '#388e3c', light: '#e8f5e9' },
  { main: '#f57c00', light: '#fff3e0' },
  { main: '#5e35b1', light: '#ede7f6' },
  { main: '#00796b', light: '#e0f2f1' },
];
